export function getTopLevelDomain(): string {
  return import.meta.env.VITE_APP_DOMAIN || window.location.hostname.split('.').reverse()[0];
}
